// Contest action types
export const FETCH_CONTESTS_REQUEST = 'FETCH_CONTESTS_REQUEST';
export const FETCH_CONTESTS_FAILURE = 'FETCH_CONTESTS_FAILURE';
export const FETCH_CONTESTS_SUCCESS = 'FETCH_CONTESTS_SUCCESS';
export const ADD_CONTEST_PLAYED = 'ADD_CONTEST_PLAYED';
export const UPDATE_CONTEST_CLOSE = `UPDATE_CONTEST_CLOSE`;
export const OMIT_CONTEST = 'OMIT_CONTEST';
export const UPDATE_CONTEST = 'UPDATE_CONTEST';
export const FETCH_CONTESTS_STATUS = 'FETCH_CONTESTS_STATUS';
